import React from 'react'

const Activities = () => {
  return (
    <h2>Activities</h2>
  )
}

export default Activities